/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import { KTIcon, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteUser} from '../../core/_requests'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { ConvertToOrder } from '../../../../../../modules/auth/core/_requests'
import { useAuth } from '../../../../../../modules/auth'

type Props = {
  user: any
}

const UserActionsCell: FC<Props> = ({user}) => {
  const {setItemIdForUpdate} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(user?.id)
  }

  const convertToOrder = async (e : any,lead:any) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    const response = await axios.post(ConvertToOrder,
        { ...lead },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (response.data.status == 1) {
        toast.success(response.data.message);
    } else {
        toast.error(response.data.message);
    }

  }

  const deleteItem = useMutation(() => deleteUser(user?.id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
    },
  })

  const handleeditoption = (e:any) => {
        e.preventDefault();
        toast.error('Converted and Cancelled Leads cannot be edited');
  }

  const handledeleteoption = (e:any) => {
        e.preventDefault();
        toast.error('Converted and Cancelled Leads cannot be deleted');
  }
    
    const {currentUser} = useAuth();
  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Actions
        <KTIcon iconName='down' className='fs-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => convertToOrder(e,user)} >
            Convert to order
          </a>
        </div>
        
{currentUser?.permissions.find((item: any) => item.name === "update_lead") ?
        <div className='menu-item px-3'>
          {(user.status != '3' && user.status != '4') ?  <Link className='menu-link px-3' to={`/admin/lead-management/update-lead/${user?.id}`}>
            Edit
          </Link>: <a className='menu-link px-3' href='#' onClick={(e) => handleeditoption(e)}>Edit</a> }
         
        </div> : null }
        {/* end::Menu item */}

        {/* begin::Menu item */}
        {currentUser?.permissions.find((item: any) => item.name === "delete_lead") ?
        <div className='menu-item px-3'>
        {(user.status != '3' && user.status != '4') ? 
          <a
            className='menu-link px-3'
            data-kt-users-table-filter='delete_row'
            onClick={async () => window.confirm('Do you want to delete?') ? await deleteItem.mutateAsync() : null}
          >
            Delete
          </a>
            :
          <a
            className='menu-link px-3'
            data-kt-users-table-filter='delete_row'
            onClick={(e) => handledeleteoption(e)}
          >
            Delete
          </a> }
        </div> : null }
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export {UserActionsCell}
